import * as getters from "./getters";
import * as mutations from "./mutations";
import * as actions from "./actions";

const state = {
	applications: [],
	active_application: null,
	application_status: null
};

export default {
	state,
	getters,
	mutations,
	actions
};
